<template>
  <div style="height:100%">
    <cTable
      ref="table"
      :fields="fields"
      :modals="modals"
      :header="header"
      :methods="methods"
    >
      <!-- <template #header>
        <Tabs type="card" v-model="tabName" @on-click="handleTab">
          <TabPane
            v-for="(item, idx) in tabList"
            :key="idx"
            :label="item.name + '(' + item.num + ')'"
            :name="item.status"
          />
        </Tabs>
      </template> -->
    </cTable>
    <!-- <print ref="print" :printData="printData"></print> -->
  </div>
</template>

<script>
import {
  getClaimList,
  auditClaim,
  getAuditRecord,
  getClaimConfig,
  printClaim,
  getClaimDuty,
  getStatusNav,
  getBindUser,
  bindAuditUser,
  addClaim,
  editClaim,
  cancelClaim,
  deleteClaim,
  uploadFile,
  deleteFile,
  getClaimDetail
} from "@/api/operation_modules/claim_list";
import { getSelectType, getKeysType } from "@/api/public";
import { getAllClient } from "@/api/user/client";
import cTable from "@/base/common/index";
import { getUser } from "@/api/user/internal";
import { mapState } from "vuex";
// import print from "./print.vue";
export default {
  name: "claim_list_branch",
  components: {
    cTable
    // print
  },

  async mounted() {
    this.selData = (await getClaimConfig()).data.payload;
    // this.selData.toStation = (await getPort({ type: 2 })).data.payload;
    // this.selData.clearance_agent = (
    //   await getTransportAgent({ type: 3 })
    // ).data.payload;
    // this.tabList = this.selData.label_type;
    // this.tabName = this.tabList[1].type;
    this.header.searchs.forEach(async item => {
      // if (item.key === "client_id")
      //   item.options = (await getAllClient()).data.payload.rows;
      // if (item.key === "service_id")
      //   item.options = (
      //     await getUser({ roleType: "CustomerService" })
      //   ).data.payload.rows;
      // if (item.key === "salesman_id")
      //   item.options = (
      //     await getUser({ roleType: "Salesman" })
      //   ).data.payload.rows;
      if (item.key === "claim_type") item.options = this.selData.claim_type;
      if (item.key === "order_type") item.options = this.selData.order_type;
      // if (item.key === "duty_type") item.options = this.selData.duty_type;
      // // if (item.key === "status") item.options = this.selData.status_type;
      // if (item.key === "duty_cause") item.options = this.selData.duty_cause;
      // if (item.key === "verify_status") item.options = this.selData.verify_type;
    });
    this.modals["auditOrder"]["fields"].forEach(async item => {
      if (item.key === "currency") item.options = this.selData.currency;
      if (item.key === "duty_type") item.options = this.selData.duty_type;
      if (item.key === "duty_cause") item.options = this.selData.duty_cause;
    });
  },
  methods: {
    // 打印
    printFun(obj) {
      printClaim(obj).then(res => {
        // if (res.data.payload.length) {
        this.printData = res.data.payload;
        // }
        // this.$refs["print"].print();
      });
    },
    // tab切换
    handleTab() {
      this.$refs["table"].pageConfig.page = 1;
      this.$refs["table"].pageConfig.size = 15;
      this.$refs["table"].resize();
      this.$refs["table"].getList();
      this.$refs["table"].getTable().recalculate(true);
    },
    // 获取颜色
    getColor(status) {
      let color = "";
      switch (status) {
        case 1:
          color = "#ff9900";
          break;
        case 3:
          color = "#ff9900";
          break;
        case 2:
          color = "#ed4014";
          break;
        case 99:
          color = "#19be6b";
          break;
        default:
          color = "#606266";
          break;
      }
      return color;
    }
  },
  computed: {
    // ...mapState({
    //   remindId: state => state.app.remindId
    // })
  },
  watch: {
    // remindId(newVal) {
    //   if (newVal) {
    //     this.$refs["table"].$refs["header"].searchForm["keywords"] = newVal;
    //     this.$refs["table"].getList();
    //     this.$store.commit("remindIdFun", 0);
    //   }
    // }
  },
  data() {
    let that = this;
    return {
      printData: {},
      selData: {},
      title: "",
      required: false,
      tabList: [],
      tabName: "",
      methods: {
        list: async params => {
          // this.tabList = (await getStatusNav()).data.payload;
          // if (!this.tabName) {
          //   this.tabName = this.tabList[1].status;
          // }
          params.type = 2;
          return getClaimList(params);
        },
        auditClaim,
        getAuditRecord,
        getSelectType,
        getKeysType,
        printClaim,
        print: obj => {
          this.printFun(obj);
        },
        getClaimDuty,
        bindAuditUser,
        addClaim,
        editClaim,
        cancelClaim,
        deleteClaim,
        getClaimDetail
        // getZhongGangList,
        // getZhongGangCount
      },
      modals: {
        auditOrder: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              if (data.verify_type !== 1) {
                for (const key in data) {
                  if (key != "verify_type" && key != "remarks" && key != "id") {
                    delete data[key];
                  }
                }
              }
              this.$page
                .handleRequestMethods("auditClaim", data, true, true, true)
                .then(e => {
                  this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: "36%"
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              verify_type: [
                {
                  required: true,
                  type: "number",
                  message: "verify type agent cannot be empty",
                  trigger: "change"
                }
              ]
              // currency: [
              //   {
              //     required: true,
              //     message: "currency cannot be empty",
              //     trigger: "change"
              //   }
              // ],
              // amount: [
              //   {
              //     required: true,
              //     message: "amount cannot be empty",
              //     trigger: "blur"
              //   }
              // ],
              // duty_type: [
              //   {
              //     required: true,
              //     type: "number",
              //     message: "duty type cannot be empty",
              //     trigger: "change"
              //   }
              // ],
              // other_duty: [
              //   {
              //     required: true,
              //     message: "other duty cannot be empty",
              //     trigger: "blur"
              //   }
              // ],
              // duty_cause: [
              //   {
              //     required: true,
              //     type: "number",
              //     message: "duty cause cannot be empty",
              //     trigger: "change"
              //   }
              // ],
              // other_cause: [
              //   {
              //     required: true,
              //     message: "other cause cannot be empty",
              //     trigger: "blur"
              //   }
              // ],
              // remarks: [
              //   {
              //     required: false,
              //     message: "remarks cannot be empty",
              //     trigger: "blur"
              //   }
              // ]
            }
          },
          grid: [
            { verify_type: 24 },
            { claim_type: 24 },
            { duty_type: 24 },
            { duty: 24 },
            { other_duty: 24 },
            { duty_cause: 24 },
            { other_cause: 24 },
            { category: 24 },
            { quantity: 24 },
            { weight: 24 },
            { volume: 24 },
            { currency: 24 },
            { amount: 24 },
            { remarks: 24 }
          ],
          fields: [
            {
              name: () => this.$t("verify_status"),
              key: "verify_type",
              component: "Radio",
              options: [
                { label: this.$t("agree"), value: 1 },
                { label: this.$t("reject_prel"), value: 2 }
              ],
              bind: {
                border: true
              },
              methods: {
                "on-change": ({ value }) => {
                  // if (value == 2) {
                  // }
                }
              }
            },
            {
              key: "currency",
              name: () => this.$t("claim") + this.$t("currency_t"),
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") + this.$t("claim") + this.$t("currency_t")
                );
              },
              options: [],
              // show({ row }) {
              //   return !row.is_show;
              // },
              disabled({ row }) {
                return row.is_show != 2;
              }
            },
            {
              key: "amount",
              name: () => this.$t("claim") + this.$t("reChAmount"),
              component: "Input",
              bind: {
                type: "number"
              },
              placeholder() {
                return (
                  this.$t("enter") + this.$t("claim") + this.$t("reChAmount")
                );
              },
              // show({ row }) {
              //   return !row.is_show;
              // },
              disabled({ formData }) {
                return formData.is_show != 2;
              }
            },
            {
              key: "duty_type",
              name: () => this.$t("Responsibility_party"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("Responsibility_party");
              },
              options: [],
              disabled({ row }) {
                return row.is_show != 1;
              },
              methods: {
                "on-change"({ value, fields, formData }) {
                  if (value && value != 99) {
                    fields.forEach(async el => {
                      if (el.key == "duty") {
                        formData.duty = undefined;
                        let data = (
                          await getClaimDuty({
                            id: value,
                            claim_id: formData.id
                          })
                        ).data.payload;
                        el.options = data;
                        this.$forceUpdate();
                      }
                    });
                  }
                }
              }
            },
            {
              key: "duty",
              name: () => this.$t("specific") + this.$t("Responsibility_party"),
              component: "Select",
              options: [],
              show({ row }) {
                return row.duty_type && row.duty_type != 99;
              },
              disabled({ row }) {
                return row.is_show != 1;
              },
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("specific") +
                  this.$t("Responsibility_party")
                );
              }
            },
            {
              key: "other_duty",
              name: () => this.$t("orther") + this.$t("Responsibility_party"),
              component: "Input",
              show({ row }) {
                return row.duty_type === 99;
              },
              disabled({ formData }) {
                return formData.is_show != 1;
              },
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("orther") +
                  this.$t("Responsibility_party")
                );
              }
            },
            {
              key: "duty_cause",
              name: () => this.$t("Responsibility_party") + this.$t("reason"),
              component: "Select",
              options: [],
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("Responsibility_party") +
                  this.$t("reason")
                );
              },
              // show({ row }) {
              //   return !row.is_show;
              // },
              disabled({ row }) {
                return row.is_show != 1;
              }
            },
            {
              key: "other_cause",
              name: () =>
                this.$t("orther") +
                this.$t("Responsibility_party") +
                this.$t("reason"),
              component: "Input",
              show({ row }) {
                return row.duty_cause === 99;
              },
              disabled({ formData }) {
                return formData.is_show != 1;
              },
              placeholder() {
                return (
                  this.$t("orther") +
                  this.$t("Responsibility_party") +
                  this.$t("reason")
                );
              }
            },
            {
              key: "quantity",
              name: () => this.$t("invoicePCS"),
              component: "Input",
              show({ row }) {
                return row.order_type == 2;
              },
              disabled({ formData }) {
                return formData.is_show != 1;
              },
              placeholder() {
                return this.$t("enter") + this.$t("invoicePCS");
              }
            },
            {
              key: "weight",
              name: () => this.$t("invoiceWeight"),
              component: "Input",
              show({ row }) {
                return row.order_type == 2;
              },
              disabled({ formData }) {
                return formData.is_show != 1;
              },
              placeholder() {
                return this.$t("enter") + this.$t("invoiceWeight");
              }
            },
            {
              key: "volume",
              name: () => this.$t("square"),
              component: "Input",
              show({ row }) {
                return row.order_type == 2;
              },
              disabled({ formData }) {
                return formData.is_show != 1;
              },
              placeholder() {
                return this.$t("enter") + this.$t("square");
              }
            },
            {
              key: "category",
              name: () => this.$t("is_goods") + this.$t("category_t"),
              component: "Input",
              show({ row }) {
                return row.order_type == 2 && row.category;
              },
              disabled({ formData }) {
                return true;
              },
              placeholder() {
                return (
                  this.$t("enter") + this.$t("is_goods") + this.$t("category_t")
                );
              }
            },
            {
              key: "claim_type",
              name: () => this.$t("application_reason"),
              component: "Input",
              disabled({ formData }) {
                return true;
              },
              placeholder() {
                return this.$t("enter") + this.$t("application_reason");
              }
            },
            {
              key: "remarks",
              name: () => this.$t("Remarks"),
              component: "Input",
              bind: {
                type: "textarea"
              },
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              }
            }
          ]
        },
        record: {
          config: {
            listFn: "list",
            modalBind: {
              width: 800
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: false
          },
          fields: [],
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => this.$t("approver"),
                key: "operate_name",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("approval_time"),
                key: "create_time",
                tooltip: true,
                minWidth: 130
              },
              {
                name: () => this.$t("result"),
                key: "content",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("approval_remark"),
                key: "remarks",
                tooltip: true,
                minWidth: 200
              },
              {
                name: () => this.$t("role_t"),
                key: "role",
                tooltip: true,
                minWidth: 100
              }
            ]
          }
        },
        extend: {
          config: {
            listFn: "list",
            modalBind: {
              width: 600
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: false
          },
          fields: [],
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => this.$t("Evidence_file") + this.$t("alipay_name"),
                key: "name",
                tooltip: true,
                minWidth: 100
              },
              {
                type: "btns",
                width: 150,
                name: () => this.$t("operation"),
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("show"),
                    type: "show",
                    fnName: "showFun",
                    bind: {
                      type: "primary"
                    }
                  }
                ],
                methods: {
                  showFun({ row }) {
                    if (row.is_doc) {
                      window.open(this.$prviewUrl + this.$globalUrl + row.src);
                    } else {
                      window.open(this.$globalUrl + row.src);
                    }
                  }
                }
              }
            ]
          }
        },
        detail: {
          config: {
            title: "B2B信息",
            formBind: {
              "label-position": "top"
            }
          },
          grid: [
            { quantity: 8, weight: 8, volume: 8 },
            { actual_quantity: 8, actual_weight: 8, actual_volume: 8 }
          ],
          fields: [
            {
              name: "件数",
              key: "quantity",
              align: "center"
            },
            {
              name: "重量(KG)",
              key: "weight",
              align: "center"
            },
            {
              name: "方数(CBN)",
              key: "volume",
              align: "center"
            },
            {
              name: "实际赔付件数",
              key: "actual_quantity",
              align: "center"
            },
            {
              name: "实际赔付重量(KG)",
              key: "actual_weight",
              align: "center"
            },
            {
              name: "实际赔付方数(CBN)",
              key: "actual_volume",
              align: "center"
            }
          ],
          footer: { show: false }
        },
        binding: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("bindAuditUser", row, true)
                .then(res => {
                  this.$page.getList();
                  this.close();
                });
            }
          },
          config: {
            rules: {
              operate_id: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ]
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ operate_id: 24 }],
          fields: [
            {
              key: "operate_id",
              name: () => this.$t("auditOrder") + this.$t("personnel"),
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("auditOrder") +
                  this.$t("personnel")
                );
              },
              options: [],
              methods: {
                async list({ row, field }) {
                  await this.$nextTick(async () => {
                    let res = (await getBindUser(row.id)).data.payload;
                    field.options = res;
                    this.$forceUpdate();
                  });
                }
              }
            }
          ]
        },
        claim: {
          methods: {
            ok({ close, row, fields }) {
              row["extend"] = row["files"];
              this.$page
                .handleRequestMethods(
                  row.id ? "editClaim" : "addClaim",
                  row,
                  true,
                  true
                )
                .then(() => {
                  this.$page.getList();
                  close();
                });
            },
            cancel() {
              this.fields.map(field => {
                if (field.key === "files") {
                  field.files = [];
                  field.extend = [];
                }
              });
            }
          },
          grid: [
            { ownership: 24 },
            { airway_number: 24 },
            { order_type: 24 },
            { claim_type: 24 },
            { other_claim: 24 },
            { quantity: 8, weight: 8, volume: 8 },
            { currency: 12, amount: 12 },
            { remarks: 24 },
            { files: 24 }
          ],
          config: {
            formBind: {
              labelWidth: 100
            },
            width: 800,
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              ownership: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              order_type: [
                {
                  required: true,
                  message: "请选择订单类型",
                  trigger: "change",
                  type: "number"
                }
              ],
              airway_number: [{ required: true, message: "请输入理赔单号" }],
              claim_type: [
                {
                  required: true,
                  message: "请选择理赔类型",
                  trigger: "change",
                  type: "number"
                }
              ],
              other_claim: [{ required: true, message: "请输入其他原因" }],
              currency: [
                { required: true, message: "请选择币种", trigger: "change" }
              ],
              amount: [
                { required: true, message: "请填写理赔金额", type: "number" }
              ]
            }
          },
          fields: [
            {
              name: () => this.$t("branchOffice"),
              key: "ownership",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("branchOffice");
              },
              options: [],
              disabled: ({ row }) => {
                return !!row.id;
              },
              methods: {
                list: ({ field }) => {
                  field.options = this.selData.ownership;
                }
              }
            },
            {
              name: () => this.$t("claim") + this.$t("Odd_Numbers"),
              key: "airway_number",
              component: "Input",
              disabled: ({ row }) => {
                return !!row.id;
              },
              placeholder() {
                return (
                  this.$t("enter") + this.$t("claim") + this.$t("Odd_Numbers")
                );
              },
              bind: {
                type: "textarea",
                autosize: {
                  minRows: 2,
                  maxRows: 5
                }
              }
            },
            {
              name: () => this.$t("claim") + this.$t("type"),
              key: "claim_type",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("claim") + this.$t("type");
              },
              options: [],
              methods: {
                list: ({ field }) => {
                  field.options = this.selData.claim_type;
                }
              }
            },
            {
              name: () => this.$t("orther") + this.$t("reason"),
              key: "other_claim",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("orther") + this.$t("reason");
              },
              show({ row }) {
                return row.claim_type === 99;
              }
            },
            {
              name: () => this.$t("order_type_t"),
              key: "order_type",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("order_type_t");
              },
              options: [],
              methods: {
                list: ({ field }) => {
                  field.options = this.selData.order_type;
                }
              }
            },
            {
              name: () => this.$t("invoicePCS"),
              key: "quantity",
              component: "InputNumber",
              placeholder() {
                return this.$t("enter") + this.$t("invoicePCS");
              },
              default: 0,
              show({ row }) {
                return row.order_type === 2;
              },
              bind: {
                style: "width:100%"
              }
            },
            {
              name: () => this.$t("invoiceWeight"),
              key: "weight",
              default: 0,
              component: "InputNumber",
              placeholder() {
                return this.$t("enter") + this.$t("invoiceWeight");
              },
              show({ row }) {
                return row.order_type === 2;
              },
              bind: {
                style: "width:100%"
              }
            },
            {
              name: () => this.$t("square"),
              key: "volume",
              component: "InputNumber",
              placeholder() {
                return this.$t("enter") + this.$t("square");
              },
              default: 0,
              show({ row }) {
                return row.order_type === 2;
              },
              bind: {
                style: "width:100%"
              }
            },
            {
              name: this.$t("order_desc"),
              key: "remarks",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              bind: {
                type: "textarea"
              },
              options: []
            },
            {
              name: () => this.$t("claim") + this.$t("currency_t"),
              key: "currency",
              component: "Select",
              placeholder() {
                return (
                  this.$t("enter") + this.$t("claim") + this.$t("currency_t")
                );
              },
              options: [],
              methods: {
                list: ({ field, formData }) => {
                  // console.log(field, formData);
                  field.options = this.selData.currency;
                  this.$nextTick(() => {
                    formData.currency = field.options[0].value;
                  });
                }
              }
            },
            {
              name: () => this.$t("claim") + this.$t("reChAmount"),
              key: "amount",
              component: "InputNumber",
              placeholder() {
                return (
                  this.$t("enter") + this.$t("claim") + this.$t("reChAmount")
                );
              },
              default: 0,
              bind: {
                style: "width:100%"
              }
            },
            {
              name: () => this.$t("Evidence_file"),
              key: "files",
              component: "Upload",
              bind: {
                fileName: "files",
                type: "drag",
                // accept: ".xlsx,.xls",
                multiple: true,
                content: this.$t("uploadText") + this.$t("uploadTe")
              },
              methods: {
                beforeUpload({ file, row }) {
                  row["file"] = file;
                  return false;
                }
              },
              methods: {
                beforeUpload: ({ file, row }) => {
                  let formData = new FormData();
                  formData.append("file", file); // 文件对象
                  uploadFile(formData).then(res => {
                    if (res.data.status) {
                      if (row["files"]) {
                        row["files"].push({
                          name: file.name,
                          url: res.data.payload
                        });
                      } else {
                        row["files"] = [
                          {
                            name: file.name,
                            url: res.data.payload
                          }
                        ];
                      }
                    }
                  });
                  return false;
                }
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          // {
          //   key: "client_id",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("clientName");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "account", value: "id" },
          //   bind: {
          //     style: "width:150px"
          //   }
          // },
          // {
          //   key: "service_id",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("serviceAccount");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "account", value: "id" },
          //   bind: {
          //     style: "width:150px"
          //   }
          // },
          // {
          //   key: "salesman_id",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("salesman");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "account", value: "id" },
          //   bind: {
          //     style: "width:150px"
          //   }
          // },
          {
            key: "claim_type",
            placeholder() {
              return this.$t("select") + this.$t("claim") + this.$t("reason");
            },
            component: "Select",
            options: []
          },
          {
            key: "order_type",
            placeholder() {
              return this.$t("select") + this.$t("order_type_t");
            },
            component: "Select",
            options: []
          },
          // {
          //   key: "duty_type",
          //   placeholder() {
          //     return this.$t("select") + this.$t("Responsibility_party");
          //   },
          //   component: "Select",
          //   options: []
          // },
          // {
          //   key: "duty_cause",
          //   placeholder() {
          //     return (
          //       this.$t("select") +
          //       this.$t("Responsibility_party") +
          //       this.$t("reason")
          //     );
          //   },
          //   component: "Select",
          //   options: []
          // },
          // {
          //   key: "status",
          //   placeholder() {
          //     return this.$t("select") + this.$t("claim") + this.$t("tip");
          //   },
          //   component: "Select",
          //   options: []
          // },
          // {
          //   key: "verify_status",
          //   placeholder() {
          //     return this.$t("select") + this.$t("verify_status");
          //   },
          //   component: "Select",
          //   options: []
          // },
          // {
          //   key: "keywordsType",
          //   placeholder() {
          //     return this.$t("select") + this.$t("keyword") + this.$t("type");
          //   },
          //   component: "Select",
          //   config: {
          //     label({ row }) {
          //       return this.$t(row.label);
          //     }
          //   },
          //   options: [],
          //   methods: {
          //     async list({ field, searchForm }) {
          //       let res = (await getKeysType("EXTRACT_SEA_KEYWORDS")).data
          //         .payload;
          //       field.options = res;
          //       searchForm[field.key] = res[0].value;
          //       this.$forceUpdate();
          //     }
          //   }
          // },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1
            },
            component: "Input"
            // default: this.$route.params.id ? this.$route.params.id : ""
          }
        ],
        btns: {
          list: [
            // {
            //   name: () => this.$t("export") + this.$t("analysis1"),
            //   type: "analysis",
            //   fnName: "analysisFun",
            //   bind: {
            //     type: "primary",
            //     icon: "md-download"
            //   }
            // },
            // {
            //   name: () =>
            //     this.$t("launch") + this.$t("branchOffice") + this.$t("claim"),
            //   type: "claim",
            //   fnName: "claimFun",
            //   bind: {
            //     type: "warning",
            //     icon: "md-arrow-round-up"
            //   }
            // },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "exportFun",
              bind: {
                type: "success",
                icon: "md-download"
              },
              disabled(row) {
                return !this.selectAll.length;
              }
            }
          ],
          methods: {
            // analysisFun({ field, searchForm }) {
            //   this.getModal("analysis").open({}, function() {
            //     this.setTitle(this.$t("analysis"));
            //   });
            // },
            exportFun({ row, field, searchForm }) {
              this.exportExc();
            },
            claimFun() {
              this.getModal("claim").open({}, function() {
                this.setTitle(
                  this.$t("launch") + this.$t("branchOffice") + this.$t("claim")
                );
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          fixed: "left",
          width: 60
        },
        {
          name: () => this.$t("Tracking number"),
          key: "airway_number",
          align: "center",
          minWidth: 120
        },
        {
          name: () => this.$t("Application_time"),
          key: "create_time",
          align: "center",
          width: 150
        },
        {
          name: () => this.$t("ownership"),
          key: "ownership_name",
          align: "center",
          minWidth: 250
        },
        {
          name: () => this.$t("b2bClient") + this.$t("accountNum"),
          key: "customer",
          align: "center",
          minWidth: 120
        },
        {
          name: () => this.$t("shipper_company_cn"),
          key: "company",
          align: "center",
          minWidth: 120
        },
        {
          name: this.$t("order_type_t"),
          key: "order_type",
          align: "center",
          tooltip: true,
          minWidth: 125,
          render(h, p) {
            return h(
              p.row.detail.order_type == 2 ? "Button" : "span",
              {
                on: {
                  click: () => {
                    if (p.row.detail.order_type == 2) {
                      this.getModal("detail").open(p.row);
                    }
                  }
                },
                attrs: {
                  size: "small",
                  type: "primary"
                }
              },
              p.row.order_type
            );
          }
        },
        {
          name: () => this.$t("claim") + this.$t("reason"),
          key: "claim_type",
          align: "center",
          minWidth: 120
        },
        {
          name: () => this.$t("claim") + this.$t("tip"),
          key: "status",
          align: "center",
          minWidth: 100,
          render: (h, p) => {
            return h(
              "span",
              {
                style: {
                  color: this.getColor(p.row.status)
                }
              },
              p.row.status_txt
            );
          }
        },
        // {
        //   name: () => this.$t("current_approver"),
        //   key: "verify_name",
        //   align: "center",
        //   width: 100
        // },
        // {
        //   name: () => this.$t("Responsibility_party"),
        //   key: "duty_type",
        //   align: "center",
        //   width: 100
        // },
        // {
        //   name: () => this.$t("Responsibility_party") + this.$t("reason"),
        //   key: "duty_cause",
        //   align: "center",
        //   width: 150
        // },
        // {
        //   name: () => this.$t("verify_status"),
        //   key: "verify_status",
        //   align: "center",
        //   width: 150
        // },
        {
          name: () => this.$t("claim") + this.$t("currency_t"),
          key: "currency",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("claim") + this.$t("reChAmount"),
          key: "amount",
          align: "center",
          minWidth: 130
        },
        {
          name: () =>
            this.$t("amount_actual") +
            this.$t("claim_pay") +
            this.$t("reChAmount"),
          key: "actual_currency",
          align: "center",
          minWidth: 130
        },
        {
          name: () =>
            this.$t("amount_actual") +
            this.$t("claim_pay") +
            this.$t("currency_t"),
          key: "actual_amount",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("DeclaredValue"),
          key: "values",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("freight_fees"),
          key: "freight",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("claim") + this.$t("Remarks"),
          key: "remarks",
          align: "center",
          minWidth: 100
        },

        // {
        //   name: () => this.$t("Evidence_file"),
        //   key: "extend",
        //   align: "center",
        //   component: "Button",
        //   minWidth: 100,
        //   bind: {
        //     type: "primary",
        //     size: "small"
        //   },
        //   // render: (h, params) => {
        //   //   return h(
        //   //     "Button",
        //   //     {
        //   //       props: {
        //   //         type: "primary",
        //   //         size: "small"
        //   //       },
        //   //       on: {
        //   //         click: () => {
        //   //           console.log(this);
        //   //           this.$refs["table"]
        //   //             .getModal("extend")
        //   //             .open(null, function() {
        //   //               this.title = this.$t("Evidence_file");
        //   //               this.list = params.row.extend;
        //   //             });
        //   //         }
        //   //       }
        //   //     },
        //   //     this.$t("Evidence_file")
        //   //   );
        //   // },
        //   methods: {
        //     render({ value }) {
        //       return this.$t("Evidence_file");
        //     },
        //     click({ row }) {
        //       this.$page.getModal("extend").open({}, function() {
        //         this.title = this.$t("Evidence_file");
        //         this.list = row.extend;
        //       });
        //     }
        //   }
        // },
        {
          name: () => this.$t("claim") + this.$t("Odd_Numbers"),
          key: "claim_number",
          align: "center",
          minWidth: 220
        },
        {
          name: () => this.$t("complete") + this.$t("time"),
          key: "complete_time",
          align: "center",
          minWidth: 150
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () =>
                this.$t("re_start") +
                this.$t("branchOffice") +
                this.$t("claim"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "warning"
              },
              show: ({ row }) => {
                return row.is_launch == 1;
              }
            },
            {
              name: () => this.$t("cancel_claim"),
              type: "cancel",
              fnName: "cancelFun",
              bind: {
                type: "error"
              },
              show: ({ row }) => {
                return row.is_cancel == 1;
              }
            }
            // {
            //   name: () =>
            //     this.$t("bind") + this.$t("auditOrder") + this.$t("personnel"),
            //   type: "bindUser",
            //   fnName: "bindUserFun",
            //   bind: {
            //     type: "warning"
            //   },
            //   show: ({ row }) => {
            //     return row.is_bind == 1 && row.status;
            //   },
            //   id: 690
            // },
            // {
            //   name: () => this.$t("Evidence_file"),
            //   type: "extend",
            //   fnName: "extendFun",
            //   bind: {
            //     type: "primary"
            //   }
            // },
            // {
            //   name: () => this.$t("auditOrder") + this.$t("record"),
            //   type: "record",
            //   fnName: "recordFun",
            //   bind: {
            //     type: "primary"
            //   },
            //   id: 679
            // },
            // {
            //   name: () => this.$t("auditOrder"),
            //   type: "auditOrder",
            //   fnName: "auditOrderFun",
            //   bind: {
            //     type: "success"
            //   },
            //   show: ({ row }) => {
            //     return row.is_verify && row.status;
            //   },
            //   id: 681
            // },
            // {
            //   name: () => this.$t("print"),
            //   type: "print",
            //   fnName: "printFun",
            //   bind: {
            //     type: "warning"
            //   },
            //   show: ({ row }) => {
            //     return row.is_print == 1;
            //   },
            //   id: 680
            // }
          ],

          methods: {
            async updateFun({ row }) {
              let data = (
                await this.handleRequestMethods("getClaimDetail", row.id)
              ).payload;
              data["files"] = data.extend;
              this.getModal("claim").open(data, function() {
                this.setTitle(
                  this.$t("update") + this.$t("branchOffice") + this.$t("claim")
                );
              });
            },
            cancelFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("cancel_claim") +
                  "：" +
                  row.claim_number +
                  "?",
                onOk: () => {
                  this.handleRequestMethods(
                    "cancelClaim",
                    {
                      id: row.id
                    },
                    true,
                    true
                  ).then(res => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                }
              });
            },
            // exportFun({ row }) {
            //   console.log("导出");
            //   this.openLoading();
            //   this.handleRequestMethods(
            //     "getExportExcel",
            //     row.id,
            //     false,
            //     true
            //   ).then(res => {
            //     console.log(res);
            //     window.open(this.$globalUrl + res.payload);
            //   });
            // },
            bindUserFun({ row }) {
              this.getModal("binding").open({ id: row.id }, function() {
                this.title =
                  this.$t("bind") +
                  this.$t("auditOrder") +
                  this.$t("personnel");
              });
            },
            extendFun({ row }) {
              this.getModal("extend").open(null, function() {
                this.title = this.$t("Evidence_file");
                this.list = row.extend;
              });
            },
            async recordFun({ row }) {
              let res = await this.handleRequestMethods(
                "getAuditRecord",
                row.id
              );
              this.getModal("record").open(null, function() {
                this.list = res.payload;
                this.setTitle(this.$t("auditOrder") + this.$t("record"));
              });
            },
            auditOrderFun({ row }) {
              let data = JSON.parse(JSON.stringify(row.detail));
              data["id"] = row.id;
              data["is_show"] = row.is_show;
              data["claim_type"] = row.claim_type;

              this.getModal("auditOrder").open(data, function() {
                this.fields.forEach(async item => {
                  if (item.key == "duty" && data.duty_type) {
                    item.options = (
                      await this.$page.handleRequestMethods("getClaimDuty", {
                        id: data.duty_type,
                        claim_id: data.id
                      })
                    ).payload;
                  }
                  if (item.key == "verify_type") {
                    switch (row.work_type) {
                      case 1:
                        item.options = [
                          { label: this.$t("agree"), value: 1 },
                          {
                            label: this.$t("reject_prel"),
                            value: 2
                          }
                        ];
                        break;
                      case 2:
                        item.options = [
                          { label: this.$t("claim_agree"), value: 1 }
                        ];
                        break;
                      case 3:
                        item.options = [
                          { label: this.$t("confirm_pay"), value: 1 }
                        ];
                        break;
                      default:
                        item.options = [
                          { label: this.$t("agree"), value: 1 },
                          {
                            label: this.$t("reject_client"),
                            value: 2
                          }
                        ];
                        break;
                    }
                  }
                });
                this.setTitle(this.$t("auditOrder"));
              });
            },
            printFun({ row }) {
              this.handleMethods("print", row.id);
            }
          }
        }
      ]
    };
  }
};
</script>
<style type="text/css">
.content {
  height: 100%;
}
/* @page{
    size: 7cm 8cm;
  } */
.city-name {
  height: 34px;
  display: inline-block;
  line-height: 34px;
  margin: 5px;
  padding: 0 5px;
  border-radius: 4px;
  border: 1px solid #e8eaec;
}
.city-div :nth-child(3n + 1).city-name {
  color: #fff;
  background-color: #59c48e;
}
.city-div :nth-child(3n).city-name {
  color: #fff;
  background-color: #403868;
}
.city-div :nth-child(3n-1).city-name {
  color: #fff;
  background-color: #616664;
}
</style>
<style lang="scss" scoped></style>
